import apiClient from '../client';
import type { PagedResult } from '../types/api';
import type {
  CreateSessionReplayRequest,
  CreateSessionReplayResponse,
  FlushSessionEventsRequest,
  EndSessionReplayRequest,
  SessionReplayModel,
  SessionReplayDetailModel,
  SessionReplayQueryParams,
} from '../types/sessionReplay';

export const sessionReplayApi = {
  // ---- Ingestion (any authenticated user) ----

  createSession: (data: CreateSessionReplayRequest) =>
    apiClient.post<CreateSessionReplayResponse>('/session-replay/sessions', data),

  flushEvents: (data: FlushSessionEventsRequest) =>
    apiClient.post<void>('/session-replay/events', data),

  endSession: (data: EndSessionReplayRequest) =>
    apiClient.post<void>('/session-replay/end', data),

  // ---- Admin read endpoints ----

  getSessions: (params: SessionReplayQueryParams) =>
    apiClient.get<PagedResult<SessionReplayModel>>('/session-replay/sessions', {
      params,
    }),

  getSession: (id: number) =>
    apiClient.get<SessionReplayDetailModel>(`/session-replay/sessions/${id}`),

  getSessionEvents: (id: number) =>
    apiClient.get<unknown[]>(`/session-replay/sessions/${id}/events`),
};
